import { render, staticRenderFns } from "./Calification.vue?vue&type=template&id=3aa8c14d"
import script from "./Calification.vue?vue&type=script&lang=js"
export * from "./Calification.vue?vue&type=script&lang=js"
import style0 from "./Calification.vue?vue&type=style&index=0&id=3aa8c14d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports